const accommodationMapping: { [key: string]: string } = {
  EXTERNAL_TOOLS: 'External tools',
  EXTRA_TIME: 'Extra time',
  BREAKS: 'Breaks',
  REFERENCE_MATERIALS: 'Reference materials',
  EXTERNAL_HELP: 'External help',
  REVIEWER: 'Reviewer',
  DISABILITIES: 'Disabilities',
  MEDICAL_EQUIPMENT: 'Medical equipment',
  EXAM_AREAS_ACCOMMODATION: 'Exam areas accommodation',
};

export const formatAccommodationType = (type: string): string => {
  return accommodationMapping[type] || type;
};
